export const DEFAULT_PROFILE_ICON_ID = 29;

export const defaultProfileIconUrl = (): string =>
  `https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/profile-icons/${String(DEFAULT_PROFILE_ICON_ID)}.jpg`;
